import {EmptyProps} from "../../../common/empty/Empty.props";
import {ListColumnType, ListHeader} from "../../../common/list/List.props";
import {ListenerStatusInfo, ListenerStatusType} from "../../constant/Status.type";

export const HEADERS: ListHeader[] = [
    {
        type: ListColumnType.CHECK_BOX,
        name: "",
        key: ""
    },
    {
        type: ListColumnType.NORMAL,
        name: "신청자명",
        key: "name"
    },
    {
        type: ListColumnType.NORMAL,
        name: "신청 일시",
        key: "applicationDate",
        convertToString: (datetime: string): string => {
            return datetime.replace("T", " ");
        }
    },
    {
        type: ListColumnType.NORMAL,
        name: "신청 인원",
        key: "headCount",
        convertToString: (headCount: number): string => {
            return `${headCount}명`;
        }
    },
    {
        type: ListColumnType.NORMAL,
        name: "연락처",
        key: "phone"
    },
    {
        type: ListColumnType.NORMAL,
        name: "이메일",
        key: "email"
    },
    {
        type: ListColumnType.STATUS,
        name: "결제 상태",
        key: "status",
        convertToString: (status: number): string => {
            return ListenerStatusInfo.ordinalToName(status);
        },
        getCellStyle: (status: number): {} => {
            return {
                color: status === ListenerStatusType.PAID? "" : "var(--red600)"
            };
        }
    }
];

export const EMPTY_PROPS = (): EmptyProps => {
    return {
        messageText: "신청자 정보가 없습니다."
    };
}